import React from "react";
import { Box, Button, Typography, Divider, Slider } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import ActivityTabRooms from "./ActivityTabRooms";
import ActivityTabObjects from "./ActivityTabObjects";

interface Room {
  id: string;
  displayName: string;
}

interface ActivityTabActivityProps {
  showCompass: boolean;
  toggleShowCompass: () => void;
  showMarma: boolean;
  toggleShowMarma: () => void;
  compassOpacity: number;
  onCompassOpacityChange: (value: number | number[]) => void;
  onSitePlanSelected: () => void;
  onGriddedBoxSelected: () => void;
  roomData: Room[] | undefined;
  isRoomLoading: boolean;
  onItemDrop: (
    itemId: string,
    itemName: string,
    itemType: string,
    x: number,
    y: number
  ) => void;
}

const ActivityTabActivity: React.FC<ActivityTabActivityProps> = ({
  showCompass,
  toggleShowCompass,
  showMarma,
  toggleShowMarma,
  compassOpacity,
  onCompassOpacityChange,
  onSitePlanSelected,
  onGriddedBoxSelected,
  roomData,
  isRoomLoading,
  onItemDrop,
}) => {
  const handleSliderChange = (e: any, newValue: number | number[]) => {
    console.log(e);
    onCompassOpacityChange(newValue);
  };

  const navigate = useNavigate();
  const { propertyId } = useParams();

  const handleGriddedBoxSelected =
    onGriddedBoxSelected ||
    (() => {
      navigate(`/analysis/${propertyId}`);
    });

  return (
    <Box>
      <Typography
        variant="subtitle1"
        sx={{ marginBottom: "12px", fontWeight: "bold" }}
      >
        Map Options
      </Typography>
      <Button
        variant="contained"
        onClick={toggleShowCompass}
        sx={{ margin: "8px 8px 8px 0", backgroundColor: "#1976d2" }}
      >
        {showCompass ? "Hide Compass" : "Show Compass"}
      </Button>
      <Button
        variant="contained"
        onClick={toggleShowMarma}
        sx={{ margin: "8px 0", backgroundColor: "#1976d2" }}
      >
        {showMarma ? "Hide Marma" : "Show Marma"}
      </Button>

      <Divider sx={{ backgroundColor: "#666", marginY: "12px" }} />

      <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
        Compass
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "12px",
        }}
      >
        <Typography variant="body2">Opacity</Typography>
        <Slider
          value={compassOpacity}
          onChange={handleSliderChange}
          min={0}
          max={1}
          step={0.1}
          sx={{
            color: "white",
            width: "60%",
            "& .MuiSlider-thumb": {
              backgroundColor: "white",
            },
          }}
        />
      </Box>

      <Divider sx={{ backgroundColor: "#666", marginY: "12px" }} />
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: "bold", marginBottom: "12px" }}
      >
        Analysis Methods
      </Typography>
      <Box sx={{ display: "flex", gap: "12px", marginBottom: "12px" }}>
        <Button
          variant="contained"
          onClick={handleGriddedBoxSelected}
          sx={{ backgroundColor: "#1976d2" }}
        >
          Gridded Box
        </Button>
        <Button
          variant="contained"
          onClick={onSitePlanSelected}
          sx={{ backgroundColor: "#1976d2" }}
        >
          Site Plan
        </Button>
      </Box>

      {/* <Typography
        variant="subtitle1"
        sx={{ marginBottom: "12px", fontWeight: "bold" }}
      >
        Shapes
      </Typography>
      <Box sx={{ display: "flex", gap: "12px", marginTop: "12px" }}>
        <Chip
          label="Line"
          onClick={() => console.log("Line tool selected")}
          sx={{
            backgroundColor: "#444",
            color: "white",
            "&:hover": { backgroundColor: "#555" },
          }}
        />
        <Chip
          label="Pencil"
          onClick={() => console.log("Pencil tool selected")}
          sx={{
            backgroundColor: "#444",
            color: "white",
            "&:hover": { backgroundColor: "#555" },
          }}
        />
      </Box>

      <Divider sx={{ backgroundColor: "#666", marginY: "12px" }} />

      <Typography
        variant="subtitle1"
        sx={{ marginBottom: "12px", fontWeight: "bold" }}
      >
        Images
      </Typography>
      <Box
        sx={{
          display: "flex",
          gap: "12px",
          flexDirection: "column",
          marginTop: "12px",
        }}
      >
        <Chip
          label="Upload Image"
          onClick={() => console.log("Upload Image")}
          sx={{
            backgroundColor: "#444",
            color: "white",
            "&:hover": { backgroundColor: "#555" },
          }}
        />
        <Chip
          label="Sync Image"
          onClick={() => console.log("Sync Image")}
          sx={{
            backgroundColor: "#444",
            color: "white",
            "&:hover": { backgroundColor: "#555" },
          }}
        />
        <Chip
          label="Copy Layer Data"
          onClick={() => console.log("Copy Layer Data")}
          sx={{
            backgroundColor: "#444",
            color: "white",
            "&:hover": { backgroundColor: "#555" },
          }}
        />
      </Box> */}
      <Divider
        sx={{
          backgroundColor: "#666",
          marginBottom: "24px",
          marginTop: "24px",
        }}
      />
      <ActivityTabRooms
        roomData={roomData}
        isRoomLoading={isRoomLoading}
        onItemDrop={onItemDrop}
      />
      <Divider
        sx={{
          backgroundColor: "#666",
          marginBottom: "24px",
          marginTop: "24px",
        }}
      />
      <ActivityTabObjects onItemDrop={onItemDrop} />
    </Box>
  );
};

export default ActivityTabActivity;
